<template>
  <div class="bbe-mark-message">
    <i class="bbe-mark-message-button"
       :class="displayPopup ? 'email-icon-mark-as-fill' : 'email-icon-mark-as'"
       @click.stop="displayPopup = !displayPopup">
     <span class="bbe-mark-message-button-tooltip">
        <transition name="bbe-bounce">
        <span class="bbe-mark-message-button-tooltip__text" v-if="!displayPopup">
        {{ tooltipText }}
      </span>
     </transition>
     </span>
    </i>
    <transition name="bbe-bounce">
      <div class="bbe-mark-message-popup"
           v-click-outside="hidePopup"
           v-show="displayPopup">
        <div class="bbe-mark-message-popup-header">
          <div class="bbe-mark-message-popup-header__item bbe-mark-message-popup-header__item_title">Mark as</div>
          <div class="bbe-mark-message-popup-header__item bbe-mark-message-popup-header__item_checkbox"
               @click="mailChecked">
            <checkbox name="markAs"
                      :disabled="defaultStatus === 3"
                      @checkboxChange="mailChecked"
                      :value="markAsIncluded"/>
            <span class="bbe-mark-message-popup-header__checkbox-text">
            {{titleExclude}}
          </span>
          </div>
        </div>
        <div class="bbe-mark-message-popup-body">
          <EmailRadioInput :options="markAsOptions"
                           :disabled="!markAsIncluded"
                           @checked="setOption"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Checkbox from '@/components/Main/FormsElements/checkbox'
import EmailRadioInput from '@/components/Main/FormsElements/EmailRadioInput'
import {find, get} from 'lodash'

export default {
  name: 'MarkMessageAs',
  props: ['defaultValues'],
  components: {
    EmailRadioInput,
    Checkbox
  },
  data () {
    return {
      tooltipText: 'Exclude from statistics',
      markAsIncluded: false,
      displayPopup: false,
      activeOption: null,
      titleExclude: 'Exclude from statistics',
      markAsOptions: [
        {id: 1, title: 'Not a client'},
        {id: 2, title: 'No reply required'},
        {id: 3, title: 'Replied in WhatsApp/Telegram'},
        {id: 4, title: 'Attended a meeting'}
      ]
    }
  },
  computed: {
    defaultStatus () {
      return get(this.defaultValues, 'status', false)
    },
    defaultOption () {
      return get(this.defaultValues, 'excludedReason', false)
    }
  },
  methods: {
    mailChecked () {
      if (this.defaultStatus === 3) return
      this.markAsIncluded = !this.markAsIncluded
    },
    setOption (optionId) {
      this.activeOption = optionId
    },
    hidePopup () {
      this.displayPopup = false
    },
    setDefaultMarkAs () {
      if (this.defaultStatus && this.defaultStatus === 3) {
        this.markAsIncluded = true
      }
    },
    setDefaultCheckedOption () {
      this.setOption(this.defaultOption)
      this.markAsOptions = this.markAsOptions.map(item => {
        if (item.id === this.defaultOption) item.checked = true
        return item
      })
    }
  },
  watch: {
    defaultStatus () {
      this.setDefaultMarkAs()
    },
    defaultOption () {
      this.setDefaultCheckedOption()
    },
    markAsIncluded (val) {
      if (!val) this.activeOption = null
    },
    activeOption (val) {
      const reason = find(this.markAsOptions, {id: val}) || {}
      this.$emit('setOption', this.markAsIncluded ? reason : {})
    }
  },
  beforeMount () {
    this.setDefaultMarkAs()
    this.setDefaultCheckedOption()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-mark-message {
  @include global-font;
  position: relative;

  &-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 14px;
    padding: 0 10px;
    border-right: 1px solid $color-gallery;
    font-size: 13px;
    line-height: 16px;
    cursor: pointer;
    user-select: none;
    color: $color-accent;
    transition: 0.3s;

    &:hover {
      color: $color-accent-hover;
    }

    &:hover  &-tooltip {
      transform: scale(1);
    }

    &-tooltip {
      @include global-font;
      position: absolute;
      bottom: 21px;
      left: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.2s;
      transform: scale(0);

      &__text {
        position: absolute;
        bottom: 0;
        left: auto;
        color: $color-white;
        font-weight: 500;
        font-size: 11px;
        padding: 4px 5px;
        background: rgba($color-black, 0.59);
        border-radius: 3px;
        z-index: 3;
        pointer-events: none;
        user-select: none;
        white-space: nowrap;
      }
    }
  }

  &-popup {
    position: absolute;
    top: 26px;
    right: 24px;
    min-width: 240px;
    background: $color-white;
    box-shadow: 0 0 10px rgba($color-accent, 0.14);
    border-radius: 6px;
    z-index: 999;

    &-header {
      padding: 15px 9px;
      border-bottom: 1px solid $color-alabaster;

      &__item {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 13px;
        line-height: 16px;
        white-space: nowrap;
        cursor: default;

        &_title {
          font-weight: 500;
          margin-bottom: 11px;
        }

        &_checkbox {
          justify-content: flex-start;
          cursor: pointer;
          transition: 0.3s;
          user-select: none;

          &:hover {
            color: rgba($color-black, 0.8)
          }
        }
      }

      &__checkbox-text {
        line-height: 1;
        margin-left: 8px;
      }
    }

    &-body {
      display: grid;
      grid-gap: 12px;
      padding: 12px 9px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/MarkMessageAs/MarkMessageAs.vue